import { Stack, styled } from "@mui/material";
import { USER_SETTING_LAYOUT_WIDTH } from "@/features/user-settings/constants/sections";

export const UserSettingContainer = styled(Stack)`
  width: 100%;
  max-width: ${USER_SETTING_LAYOUT_WIDTH}px;
  margin: 0 auto;
  gap: 24px;
`;
